import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16df0f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "school" }
const _hoisted_2 = { class: "school__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course_track = _resolveComponent("course-track")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.school.name), 1),
    (_ctx.courseTracks.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.courseTracks, (courseTrack, index) => {
          return (_openBlock(), _createBlock(_component_course_track, {
            key: 'courseTrack' + index,
            courseTrack: courseTrack,
            schoolID: _ctx.school.id,
            class: "course-track"
          }, null, 8, ["courseTrack", "schoolID"]))
        }), 128))
      : _createCommentVNode("", true),
    (!_ctx.onlyOneCourseTrack)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "school__button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCourseTracks(_ctx.school.id, !_ctx.isAllLoaded)))
        }, _toDisplayString(_ctx.isAllLoaded ? "Ver menos trilhas" : "Ver mais trilhas"), 1))
      : _createCommentVNode("", true)
  ]))
}